//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ZoneSelect from './_zone_select'
import PriceSelect from './_price_select'
import DecorateSelect from './_decorate_select'
import InterestingSelect from './_decorate_select'
import ZonesMultipleSelect from './_zone_multiple_select'
import HammerPrice from './_hammer_price'
import OrderSelect from './_order_select'
import TimeSelect from './_time_select'
import UseType from './_usage'

import { getLayoutOpts, getAreaOpts } from './constant'
import MultiSelect from './multi_select'

const getDefaultText = () => {
    return {
        '区域': '区域',
        '城区': '',
        '地铁': '',
        '价格': '价格',
        '户型': '户型',
        '面积': '面积',
        '装修': '装修',
        '成交价': '成交价',
        '用途': '用途',
        '附近': '',
        '环线': ''
    }
}

export default {
    data () {
        return {
            selected: '',
            metro: '',
            text: getDefaultText(),
            layout_opts: getLayoutOpts(),
            area_opts: getAreaOpts()
        }
    },
    created () {
        this.$watch(function () {
            return this.text['城区'] + this.text['地铁'] + this.text['环线'] + this.text['附近']
        }, function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.text['区域'] = newVal || '不限'
            }
        })
    },
    computed: {
        open () {
            return this.selected
        }
    },
    onUnload () {
        this.text = getDefaultText()
        this.hideSelect()
    },
    methods: {
        onSelect (e) {
            const { tab } = e.currentTarget.dataset
            const no_change = tab === this.selected
            if (no_change) {
                this.selected = ''
            } else {
                this.selected = tab
            }
            this.$emit('toggleFilter', !no_change)
        },
        changeZoneMetro ({ zone_ids, text, zone_section_ids, metro, nearby, location, ring_road }) {
            this.text['城区'] = text === '不限' ? '' : text
            this.text['地铁'] = metro
            this.text['环线'] = ring_road ? ring_road.text : ''
            this.hideSelect()
            this.$emit('change', {
                zone_ids,
                zone_section_ids,
                metro,
                distance: nearby ? nearby.value : '',
                location,
                ring_road: ring_road ? ring_road.value : ''
            })
        },
        changePrice (type, temp_price, selected_tx) {
            this.text['价格'] = selected_tx
            this.hideSelect()
            const total_price = type === 'water' ? temp_price : ''
            const price = type === 'square' ? temp_price : ''
            this.$emit('change', {
                total_price,
                price
            })
        },
        changeOrder ({ value, text }) {
            this.hideSelect()
            this.$emit('change', {
                interesting_order: value
            })
        },
        changeTime ({ value }) {
            this.hideSelect()
            this.text['时间'] = value || '时间'
            this.$emit('change', {
                estimated_presell_time: value
            })
        },
        changeLayout (layout) {
            this.text['户型'] = layout
            this.hideSelect()
            this.$emit('change', {
                layout
            })
        },
        changeArea (area, text) {
            this.text['面积'] = text
            this.hideSelect()
            this.$emit('change', {
                area
            })
        },
        changeDecorate (decoration) {
            this.text['装修'] = decoration || '不限'
            this.hideSelect()
            this.$emit('change', {
                decoration
            })
        },
        hideSelect () {
            this.selected = ''
            this.$emit('toggleFilter', false)
        },
        changeZones (zone_ids, text) {
            this.text['区域'] = text
            this.hideSelect()
            this.$emit('change', {
                zone_ids
            })
        },
        changeUseType (land_usage) {
            this.text['用途'] = land_usage
            this.hideSelect()
            this.$emit('change', {
                land_usage
            })
        },
        changeHammerPrice (hammer_prices, text) {
            this.text['成交价'] = text
            this.hideSelect()
            this.$emit('change', {
                hammer_prices
            })
        }
    },
    components: {
        OrderSelect,
        TimeSelect,
        ZoneSelect,
        PriceSelect,
        DecorateSelect,
        ZonesMultipleSelect,
        InterestingSelect,
        HammerPrice,
        UseType,
        MultiSelect
    },
    props: {
        tabs: {
            type: Array
        },
        decoration: {
            type: String
        },
        zone_ids: {
            type: String
        },
        zone_section_ids: {
            type: String
        },
        area: {
            type: String
        },
        total_price: {
            type: String
        },
        price: {
            type: String
        },
        layout: {
            type: String
        },
        className: {
            type: String
        },
        auction: {
            type: Boolean,
            default: false
        },
        zones: {
            type: [Object, null]
        },
        show_section: {
            type: Boolean,
            default: false
        },
        show_nearby: Boolean,
        latitude: [String, Number],
        longitude: [String, Number],
        show_ring_road: Boolean,
        interesting_order: String,
        estimated_presell_times: Array,
        estimated_presell_time: String,
    }
}
